module.exports = __webpack_public_path__ + "static/quiz_stage_1_bg-028cca78e5ddc68859140b9c4745df6f.svg";